import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { NbiForm } from "@/features/nbi/components/NbiForm"
import { NbiLayout } from "@/features/nbi/components/NbiLayout"
import { ApplicationsLandingPage } from "@/features/nbi/components/ApplicationsLandingPage"
import { ValidationProvider } from "@/features/nbi/context/ValidationContext"
import { STEP_NAMES } from "@/features/nbi/utils/step-mapping"
import { useNbiFormSubmitRef } from "@/routes/__root"

const applicationSearchSchema = z.object({
  step: z.union([
    z.number().min(0).max(12),
    z.enum(STEP_NAMES),
  ]).optional(),
  appId: z.number().optional(),
})

type ApplicationSearch = z.infer<typeof applicationSearchSchema>

const ApplicationPage = () => {
    const formSubmitRef = useNbiFormSubmitRef()
    const { step } = Route.useSearch()

    if (!step) {
        return (
            <NbiLayout>
                <div className="py-10 px-10 pb-30 w-full self-center hark-scrollbar justify-center">
                    <ApplicationsLandingPage />
                </div>
            </NbiLayout>
        )
    }

    return (
        <ValidationProvider>
            <NbiLayout>
                <NbiForm formSubmitRef={formSubmitRef!} />
            </NbiLayout>
        </ValidationProvider>
    )
}

export const Route = createFileRoute("/_authenticated/agent/application/")({
    component: ApplicationPage,
    validateSearch: (search): ApplicationSearch => {
        return applicationSearchSchema.parse(search)
    },
})